// @flow

/**
 * Set customer in session
 * @type obj
 */
window.set_customer_storaged = function(customer){
    // function for set data of session customer in sessionStorage
    sessionStorage.client_id = customer.id;
    sessionStorage.identification = customer.identification;
    sessionStorage.full_name = customer.full_name;
    sessionStorage.cell = customer.cell;
};

/**
 * Get customer in session
 * @type obj
 */
window.get_customer_storaged = function(){
    return {
        id: sessionStorage.client_id,
        identification: sessionStorage.identification,
        full_name: sessionStorage.full_name,
        cell: sessionStorage.cell,
        label: `${sessionStorage.full_name} | ${sessionStorage.identification}`
    };
};


window.clean_customer_storage = function(){
    $.each(['client_id', 'identification', 'full_name', 'cell'], function (i, value) {
        sessionStorage.removeItem(value);
    });
};



/**
 * Set company id for window session
 * @type string
 */
window.set_company_id = function(company_id){
    sessionStorage.company_id = company_id;
};

/**
 * get company id for window session
 * @return string
 */
window.get_company_id = function(){
    return sessionStorage.company_id;
};


(function() {
    // set company in session storage for keep company session
    sessionStorage.company_id = $.cookie('company_id') || '';

    // counter save obj
    window.ADD_OBJ_COUNTER = parseInt(localStorage.getItem('ADD_OBJ_COUNTER') || 0);
    $('.submit-row').click(function () {
        localStorage.ADD_OBJ_COUNTER = window.ADD_OBJ_COUNTER += 1;
    });


    $(document).ready(function () {
        if ($(window).width() < 563) {
            $(".jSignature").attr('width', '300').attr('style', 'width:100%');
        }

        function update_cookie() {
            // update cookie for keep session in multiple windows
            let expires_date = new Date();
            expires_date.setTime(expires_date.getTime() + (setting_s.SESSION_COOKIE_AGE * 1000));

            if(sessionStorage.client_id) {
                $.cookie('client_id',
                    sessionStorage.client_id, {path: '/', expires: expires_date});
            };

            if(sessionStorage.company_id) {
                $.cookie('company_id',
                    sessionStorage.company_id, {path: '/', expires: expires_date});
            };
        }

        $("form").submit(function () {
            update_cookie();
        });

        $(window).bind('beforeunload', function () {
            update_cookie();
            if ($(window).width() <= 578) {
                $.cookie("class_menu", '', {path: '/'});
            }
        });


        window.set_session_in_search = function(params){
            // let usp = new URLSearchParams(search);
            params.set('_company_id', sessionStorage.company_id);
            params.set('_client_id', sessionStorage.company_id);
            params.set('_user_id', VAR_USER_PK);
            params.set('_user_db_id', VAR_USER_DB);
            return params;
        };

        window.set_session_in_href = function(ele){
            let href = ele.getAttribute('href');
            if (!href || href[0] == '#' || href[0] != '/'){
                return;
            }

            //let url = new URL(href);
            let search = new URLSearchParams(ele.search);
            ele.href = ele.pathname + '?' + set_session_in_search(search).toString() + ele.hash;
        };

        $(document).on('click', 'a', function(){
            set_session_in_href(this);
        });

        $(document).on('contextmenu', 'a', function(){
            set_session_in_href(this);
        });

        var realSend = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
            update_cookie();

            realSend.apply(this, arguments);
        };

        $('#close_session_link').click(function () {
            localStorage.clear();
            sessionStorage.clear();
        });

        $('.glyphicon-question-sign[title]').tooltip();

        //open chat for help icon
        var help_loaded = false;
        $('.help-icon-s').click(function(){
            if (!help_loaded){
                window.$zoho = window.$zoho || {};
                $zoho.salesiq = $zoho.salesiq ||
                    {
                        widgetcode: "fe75522edb8f2d7ee1eb4f8f9e51ff8020ace3c512e22ce2c0c3780ba53d1e29427d5c1c7ae89ec53c2346bb651ae231",
                        values: {
                            'name': VAR_USER_NAME,
                            'email': VAR_USER_EMAIL,
                        },
                        ready: function () {
                            $zoho.salesiq.floatwindow.visible("show");
                        }
                    };

                $('body').append("<div id='zsiqwidget'></div>");
                // $.getScript('https://salesiq.zoho.com/widget', function () {
                //
                // });
                var d = document;
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.id = "zsiqscript";
                s.defer = true;
                s.src = "https://salesiq.zoho.com/widget";
                t = d.getElementsByTagName("script")[0];
                t.parentNode.insertBefore(s, t);

                help_loaded = true;
            }else{
                $zoho.salesiq.floatwindow.visible("show");
            }
        });

        // update user in session when autocomplete use change
        $('select[id=id_user], select[id=id_patient]')
            .on('select2:select', function(e){
                let client_id = e.params.data.id;

                if(!client_id){
                    return;
                }

                $.cookie('client_id', client_id, {path:'/'});

                $.ajax({
                    url: '/base_model_s/search_client/',
                    data: {'client': client_id}
                }).success(function(data) {
                    if (data.alert){
                        alert(data.alert);
                    }
                    set_customer_storaged(data);
                });
            }
        );


        // insert logo image
        $('#side-menu__add_logo_input').on('change', function(){
            if(! this.files.length){
                return;
            }
            var formData = new FormData();
            formData.append('user_photo', this.files[0]);
            const parent = $(this).parent();
            set_load_spinner(parent);
            $.ajax({
                url: `/api/v1/base_model_s/company/${sessionStorage.company_id}/`,
                method: 'PATCH',
                contentType: false,
                processData: false,
                //contentType: 'multipart/form-data',
                data: formData,
                success: function(company){
                    $('#logo1').css('background-image', `url(${company.user_photo})`);
                },
                error: function(response){
                    alert(response.responseText);
                },
                complete: function(){
                    remove_load_spinner(parent);
                }
            });
        });


        // $(window).keypress(function(event){
        //     console.log(event.which);
        //     if(event.which == 115 && event.ctrlKey){
        //         // Ctrl + s
        //         $('.hotkey-ctrl-s').click();
        //         event.preventDefault();
        //         return false;
        //
        //     }
        // });

        // Detect hot-keys
        $(window).bind('keydown', function(event) {
            if (event.ctrlKey || event.metaKey) {
                switch (String.fromCharCode(event.which).toLowerCase()) {
                case 's':
                    event.preventDefault();
                    $('.hotkey_ctrl-s').click();
                    break;
                // case 'f':
                //     event.preventDefault();
                //     alert('ctrl-f');
                //     break;
                // case 'g':
                //     event.preventDefault();
                //     alert('ctrl-g');
                //     break;
                }
            }
        });


    });

}());

//]]>

